import { render, staticRenderFns } from "./CatalogTree.vue?vue&type=template&id=66fd89b5&scoped=true"
import script from "./CatalogTree.vue?vue&type=script&lang=js"
export * from "./CatalogTree.vue?vue&type=script&lang=js"
import style0 from "./CatalogTree.vue?vue&type=style&index=0&id=66fd89b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd89b5",
  null
  
)

export default component.exports